import { Image as ImageIcon } from "lucide-react";

import type { SourceRef } from "../../../api/generated/model";
import { useRefPicture } from "../../../platform/media/ref-picture";
import classes from "./ad-copies.module.css";

/**
 * The picture a copy was written from (live's `referenceUrl`, its placeholder when none), read
 * from its source as any source is (G8: no `reference_url`): a library image, or a job's output.
 */
export function ReferencePicture(props: {
  teamId: string;
  brandId: string;
  reference: SourceRef | null;
}) {
  const url = useRefPicture(props.teamId, props.brandId, props.reference).still;
  return url === null ? (
    <span className={`${classes.reference} ${classes.tileStyle}`} aria-hidden>
      <ImageIcon size={20} strokeWidth={1.5} />
    </span>
  ) : (
    <img src={url} alt="The inspiration" className={classes.reference} />
  );
}
